import React, { FC, useCallback, useMemo } from 'react';
import { IntegrationField, Option } from 'api/integrations';
import { Select } from 'components/atoms/select';

type OnChangeParams = {
  integrationFieldId?: string;
  valueStr?: string[];
};

type IntegrationMultiSelectField = {
  field: IntegrationField;
  onChange?: (data: OnChangeParams) => void;
  value?: string[];
  loading?: boolean;
  disabled?: boolean;
  placeholder?: string;
  options?: Option[];
};
export const IntegrationMultiSelectField: FC<IntegrationMultiSelectField> = ({
  field,
  onChange,
  options = [],
  value = [],
  placeholder = '',
  loading,
  disabled,
}) => {
  const integrationId = field.integrationFieldId;

  const transformedOptions = useMemo(
    () =>
      (options ?? [])
        ?.filter((e) => e != null)
        ?.map((option) => ({
          value: option.valueStr,
          valueStr: option.valueStr,
          label: option.label,
          integrationFieldId: integrationId,
        })),
    [options, integrationId],
  );

  const selected = useMemo(
    () =>
      (transformedOptions ?? [])?.filter((option) =>
        (value ?? []).includes(option?.valueStr),
      ),
    [transformedOptions, value],
  );

  const handleOnChange = useCallback(
    (data?: Option[]) => {
      if (onChange != null) {
        onChange({
          integrationFieldId: field?.integrationFieldId,
          valueStr: (data ?? [])
            ?.filter((e) => e != null)
            ?.map((e) => e?.valueStr),
        });
      }
    },
    [onChange, field],
  );

  return (
    <Select
      isMulti
      placeholder={placeholder}
      value={selected}
      options={transformedOptions}
      onChange={handleOnChange}
      isLoading={loading}
      isDisabled={loading || disabled}
      isClearable
    />
  );
};
